import React, { useEffect, useRef, useState } from 'react';
import { LockIcon, LockOpenIcon, LoaderIcon } from 'lucide-react';
import { backups as seed } from '../../../data/beheer/system';
import { db } from '../../../utils/db';
import type { Backup } from '../../../types/beheer';
const STATUS: Record<Backup['status'], {
  label: string;
  tone: string;
}> = {
  ok: {
    label: 'ok',
    tone: 'text-ink-soft'
  },
  loopt: {
    label: 'loopt…',
    tone: 'text-accent'
  },
  verouderd: {
    label: 'verouderd',
    tone: 'text-amber'
  }
};
export function Backups() {
  const [items, setItems] = useState(seed);
  const timers = useRef<number[]>([]);
  useEffect(() => () => timers.current.forEach(t => window.clearTimeout(t)), []);
  const runNow = (id: string) => {
    setItems(list => list.map(b => b.id === id ? {
      ...b,
      status: 'loopt'
    } : b));
    timers.current.push(window.setTimeout(() => {
      const b = seed.find(x => x.id === id);
      setItems(list => list.map(x => x.id === id ? {
        ...x,
        status: 'ok',
        lastRun: `vandaag ${db.getState().meta.time}`
      } : x));
      if (b) db.log({
        agent: 'systeem',
        summary: `Back-up "${b.name}" handmatig gemaakt`,
        level: 'zelf',
        where: 'lokaal',
        outcome: 'uitgevoerd'
      });
    }, 2200));
  };
  return <ul className="divide-y divide-white/[0.06] rounded-3xl border border-white/[0.07] bg-night-900 px-5" data-id="element-403" data-mp="1mjhbegpb6a3c">
      {items.map(b => {
      const s = STATUS[b.status];
      return <li key={b.id} className="flex items-center gap-4 py-4" data-id="element-404" data-mp="1wa3krt6fm4dl">
            <div className="min-w-0 flex-1" data-id="element-405" data-mp="218wzfoxgg1fc">
              <p className="text-[15px] text-ink" data-id="element-406" data-mp="21bsyxhoyay5w">{b.name}</p>
              <p className="mt-0.5 flex flex-wrap items-center gap-x-2 text-[13px] text-ink-muted" data-id="element-407" data-mp="25ccx8ol9g7tm">
                <span data-id="element-408" data-mp="2a9bp10hgc2on">{b.schedule}</span>
                <span aria-hidden data-id="element-409" data-mp="2a8a9aiphqs0l">·</span>
                <span className="tabular-nums" data-id="element-410" data-mp="ay2629h711ko">{b.lastRun}</span>
                <span aria-hidden data-id="element-411" data-mp="azn1s2f8uqk4">·</span>
                <span className="tabular-nums" data-id="element-412" data-mp="fxes4s08q4m7">{b.size}</span>
                <span aria-hidden data-id="element-413" data-mp="1j79f8r048i5q">·</span>
                <span className="inline-flex items-center gap-1" data-id="element-414" data-mp="1j8apwud7z2mx">
                  {b.encrypted ? <LockIcon className="h-3 w-3" aria-hidden data-id="element-415" data-mp="1e8puuv167efh" /> : <LockOpenIcon className="h-3 w-3 text-amber" aria-hidden data-id="element-416" data-mp="1ea0tyhjo7y09" />}
                  {b.target}
                  {!b.encrypted && <span className="text-amber" data-id="element-417" data-mp="1n8unfz1pg89l">, onversleuteld</span>}
                </span>
              </p>
            </div>
            <span className={`flex items-center gap-1.5 whitespace-nowrap text-[13px] ${s.tone}`} data-id="element-418" data-mp="225lsanu5ec6l">
              {b.status === 'loopt' && <LoaderIcon className="h-3.5 w-3.5 animate-spin" aria-hidden data-id="element-419" data-mp="1x69521zd733h" />}
              {s.label}
            </span>
            <button type="button" disabled={b.status === 'loopt'} onClick={() => runNow(b.id)} className="whitespace-nowrap rounded-full px-3 py-1.5 text-[13px] font-medium text-ink-soft transition-colors duration-150 hover:bg-white/[0.06] hover:text-ink disabled:opacity-40" data-id="element-420" data-mp="2axnlq25sus7d">
              Nu maken
            </button>
          </li>;
    })}
    </ul>;
}